/* eslint-disable react/prop-types */
/* eslint-disable prettier/prettier */
import React, { useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Slide from "@mui/material/Slide";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { Icon } from "@mui/material";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ModalExitoTemporal = ({ open, onClose, duration = 3000 }) => {
  useEffect(() => {
    if (open) {
      const timer = setTimeout(onClose, duration);
      return () => clearTimeout(timer);
    }
  }, [open, onClose, duration]);

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={onClose}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle style={{ backgroundColor: "#1a2035", color: "white", textAlign: "center" }}>
        <Icon sx={{ fontSize: "50px !important", color: "#4CAF50" }}>check_circle</Icon>
      </DialogTitle>
      <DialogContent style={{ backgroundColor: "#1a2035", textAlign: "center" }}>
        <MDBox>
          <MDTypography variant="h4" color="white" fontWeight="bold">
            ¡Su solicitud fue enviada con éxtio!
          </MDTypography>
          <MDTypography variant="body1" color="white">
            En breve recibirá una respuesta.
          </MDTypography>
        </MDBox>
      </DialogContent>
    </Dialog>
  );
};

export default ModalExitoTemporal;
